export const LANDING_CREATIVE_ALLOWED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg'];
export const LANDING_CREATIVE_ALLOWED_FORMAT_EXTENSIONS = '.png,.jpg,.jpeg';

export const SWITCH_IN_CREATIVE_ALLOWED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
export const SWITCH_IN_CREATIVE_ALLOWED_FORMAT_EXTENSIONS = '.png,.jpg,.jpeg,.gif';

export const HIGH_IMPACT_CREATIVE_ALLOWED_FORMATS = ['image/jpeg', 'image/jpg'];
export const HIGH_IMPACT_CREATIVE_ALLOWED_FORMAT_EXTENSIONS = '.jpg,.jpeg';

export const CREATIVE_FORMAT_IMAGE_PNG = 'image/png';
export const CREATIVE_FORMAT_IMAGE_PNG_EXTENSION = '.png';

export const ALLOWED_VIDEO_FORMATS = 'video/mp4';

export function isCreativeFormatValid(file: File[], allowedFormats: string[]): boolean {
  return allowedFormats.includes(file[0].type);
}
